import React, { Component } from "react";
import "./App.scss";
import NavBar from "./NavBar/NavBar";
import { HashRouter, BrowserRouter, Route } from "react-router-dom";
import ScrollToTop from "./NavBar/ScrollToTop";
import Home from "./Pages/Home/Home";
import AboutUs from "./Pages/AboutUs/AboutUs";
import ManufacturingCapabilities from "./Pages/ManufacturingCapabilities/ManufacturingCapabilities";
import Pulverizing from "./Pages/ManufacturingCapabilities/Pulverizing/Pulverizing";
import Screening from "./Pages/ManufacturingCapabilities/Screening/Screening";
import Blending from "./Pages/ManufacturingCapabilities/Blending/Blending";
import Repackaging from "./Pages/ManufacturingCapabilities/Repackaging/Repackaging";
import ContactUs from "./Pages/ContactUs/ContactUs";
import ContactForm from "./ContactForm/ContactForm";
import Footer from "./Footer/Footer";

import styles from "./NavBar/TopNavBar.module.scss";

class App extends Component {
  state: {
    loaded: boolean;
  };

  constructor(props: any) {
    super(props);
    this.state = { loaded: false };
  }

  componentDidMount() {
    this.setState({ loaded: true });
  }

  render() {
    return (
      <div
        id="app"
        style={{ visibility: this.state.loaded ? "visible" : "hidden" }}
      >
        <NavBar scrollPosition={0} dropDownClosed={true} />
        <ScrollToTop>
          <div id={styles.content}>
            <Route exact path="/" component={Home} />
            <Route path="/about-us" component={AboutUs} />
            <Route
              exact
              path="/manufacturing-capabilities"
              component={ManufacturingCapabilities}
            />
            <Route
              exact
              path="/manufacturing-capabilities/pulverizing"
              component={Pulverizing}
            />
            <Route
              exact
              path="/manufacturing-capabilities/screening"
              component={Screening}
            />
            <Route
              exact
              path="/manufacturing-capabilities/blending"
              component={Blending}
            />
            <Route
              exact
              path="/manufacturing-capabilities/repackaging"
              component={Repackaging}
            />
            <Route path="/contact-us" component={ContactUs} />
          </div>
        </ScrollToTop>
        <ContactForm />
        <Footer />
      </div>
    );
  }
}

export default App;
